const hasMinimumLength = (string: string, length: number) => {
  return string.length >= length;
};

const hasSpecialCharacters = (string: string) => {
  return /\W/.test(string);
};

const hasNumber = (string: string) => {
  return /\d/.test(string);
};

const hasLowerAndUpperCase = (string: string) => {
  const hasLowerCase = string.toUpperCase() !== string;

  const hasUpperCase = string.toLocaleLowerCase() !== string;
  return hasLowerCase && hasUpperCase;
};

const passwordValidationRules = (password: string) => [
  {
    name: 'LOGIN.CREATE_PASSWORD.RULE.AT_LEAST_8_CHARS',
    validator: () => hasMinimumLength(password, 8),
  },
  {
    name: 'LOGIN.CREATE_PASSWORD.RULE.UPPER_AND_LOWER_CASE',
    validator: () => hasLowerAndUpperCase(password),
  },
  {
    name: 'LOGIN.CREATE_PASSWORD.RULE.SPECIAL_CHARS',
    validator: () => hasSpecialCharacters(password),
  },
  {
    name: 'LOGIN.CREATE_PASSWORD.RULE.NUMBER',
    validator: () => hasNumber(password),
  },
];

export default passwordValidationRules;
